export default __webpack_public_path__ + "static/media/platziconf-logo.c1d00c3e.svg";